import $ from 'jquery'

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

$("body").on("click", ".home-banner-close", function (e) {
  e.stopImmediatePropagation();
  e.preventDefault();
  setCookie('banner_closed', 'true', 1); // Set cookie for 1 day
  $(this).closest("#home-banner").fadeOut();
});